type Tprops = {
  pass: {
    arrChildren: any[];

    args: any;
  };
};

export const Shadows = (props: Tprops) => {};
